/**
 * Coupon Journey API client for tier contractual messaging.
 */
(function (global) {
  const DEFAULT_API_BASE = "https://api-v1.mamaearth.in";

  function getConfig() {
    return global.Shopify?.couponJourneyConfig || {};
  }

  function getApiBaseUrl() {
    const url = getConfig().apiBaseUrl || DEFAULT_API_BASE;
    return String(url).replace(/\/$/, "");
  }

  function parseTagsAttribute(value) {
    if (!value) return [];
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return String(value)
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean);
    }
  }

  function getDomLineItemMeta() {
    const byProductId = {};
    document
      .querySelectorAll("[data-product-id][data-product-tags]")
      .forEach((el) => {
        const productId = el.getAttribute("data-product-id");
        if (!productId) return;
        byProductId[productId] = {
          tags: parseTagsAttribute(el.getAttribute("data-product-tags")),
          unitMrp: parseFloat(el.getAttribute("data-unit-mrp")),
        };
      });
    return byProductId;
  }

  function buildCartItemsPayload(cart) {
    if (!cart?.items?.length) return [];
    const domMeta = getDomLineItemMeta();

    return cart.items.map((item) => {
      const productId = String(item.product_id);
      const meta = domMeta[productId] || {};
      const priceFromDom = meta.unitMrp;
      const priceFromCart =
        typeof item.original_price === "number"
          ? item.original_price / 100
          : typeof item.price === "number"
            ? item.price / 100
            : 0;

      return {
        productId,
        price: Number.isFinite(priceFromDom) ? priceFromDom : priceFromCart,
        quantity: item.quantity,
        tags: meta.tags || [],
      };
    });
  }

  function getCartLineQtySum(cart) {
    if (!cart?.items?.length) return 0;
    return cart.items.reduce((sum, item) => sum + (item.quantity || 0), 0);
  }

  function fetchCouponJourney(cart, showCartLadder) {
    const items = buildCartItemsPayload(cart);
    if (!items.length) {
      return Promise.resolve(null);
    }

    const query = showCartLadder ? "true" : "false";
    const url = `${getApiBaseUrl()}/v1/cart/coupon-journey?showCartLadder=${query}`;

    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-platform": "web",
      },
      body: JSON.stringify({ cartItems: items }),
    }).then((res) => {
      if (!res.ok) {
        throw new Error(`coupon-journey HTTP ${res.status}`);
      }
      return res.json();
    });
  }

  global.Shopify = global.Shopify || {};
  global.Shopify.couponJourney = {
    buildCartItemsPayload,
    fetchCouponJourney,
    getCartLineQtySum,
    getEmptyCartMessage() {
      return (
        getConfig().emptyCartMessage ||
        "Add items worth ₹399 to get FREE DELIVERY"
      );
    },
    isEnabled() {
      return getConfig().enabled !== false;
    },
  };
})(window);
